import styled from "styled-components";
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const PanicButtonMobileOverlayBox = styled.div`
    display: none;
    position:absolute;
    width: 100vw;
    height: 100vh;
    background-color:rgba(0, 0, 0, 0);
    top:0;
    left:0;
    z-index: 106;
    
    &.${ACTIVE}{
        display: block;
    }
`;